import { ActionReducerMapBuilder, UnknownAction } from '@reduxjs/toolkit';

export function generateBoilerplateAsyncThunkMatchers<StateType extends object>(
  builder: ActionReducerMapBuilder<StateType>,
  actionsPrefix: string,
) {
  builder.addMatcher(
    (action: UnknownAction) =>
      (action.type as string).startsWith(actionsPrefix) &&
      (action.type as string).endsWith('/fulfilled'),
    (state) => {
      Object.assign(state, {
        isLoading: false,
        status: 'success',
      });
    },
  );
  builder.addMatcher(
    (action: UnknownAction) =>
      (action.type as string).startsWith(actionsPrefix) &&
      (action.type as string).endsWith('/pending'),
    (state) => {
      Object.assign(state, {
        isLoading: true,
        status: 'loading',
        error: '',
      });
    },
  );
  builder.addMatcher(
    (action: UnknownAction) =>
      (action.type as string).startsWith(actionsPrefix) &&
      (action.type as string).endsWith('/rejected'),
    (state, action) => {
      Object.assign(state, {
        isLoading: false,
        status: 'failure',
        error: action || '',
      });
    },
  );
}
